$("document").ready(function() {    

    $('#mi-corpo-colos-success-announce-new-registration').toggle();
    $('#mi-corpo-colos-success-announce-activation-code').toggle();
    $('#mi-corpo-colos-success-announce-download-form').toggle();

    $('[name = "Reg_ZipCode"]').attr("disabled", "disabled");
    $('[name = "Reg_City"]').attr("disabled", "disabled");

    $('[name = "Reg_Country"]').change(function () {
        if ($('[name = "Reg_Country"]').val() == "") {
            $('[name = "Reg_ZipCode"]').attr("disabled", "disabled");
            $('[name = "Reg_City"]').attr("disabled", "disabled");
        } else {
            $('[name = "Reg_ZipCode"]').removeAttr("disabled");
            $('[name = "Reg_City"]').removeAttr("disabled");
        }
    });

    $('[name = "Reg_ZipCode"]').keyup(function () {
        var country = getThreeCode($('[name = "Reg_Country"]').val());
        var postalCode = $('[name = "Reg_ZipCode"]').val();
        try {
            jsonData = jQuery.parseJSON(httpGet("https://wpwsc.egoncloud.com:1252/Egon/EgonLstJSON?LST=LstZip&CDXZIP=" + postalCode + "&MAXLIVLOC=8&TPXEXT=L&USER=WPTC04LCA01&PASW=Y0YGKFKH&WPXISO=" + country));
            if (jsonData.LSTERR.DSXERR == "Ok") {
                //jsonData.ZIP_AREA_OUT.ZIP[x].DSXOBJDPT -->> PROVINCIA
                //jsonData.ZIP_AREA_OUT.ZIP[x].DSXOBJCNL -->> CIUDAD/POBLACI�N
                //jsonData.ZIP_AREA_OUT.ZIP[x].DSXOBJDS1 -->> DISTRITO

                if (jsonData.ZIP_AREA_OUT.ZIP.length >= 1) {
                    $('[name = "Reg_City"]').val(jsonData.ZIP_AREA_OUT.ZIP[0].DSXOBJCNL);
                }
                if (jsonData.ZIP_AREA_OUT.ZIP.length == 1) {
                    $('[name = "Reg_City"]').val(jsonData.ZIP_AREA_OUT.ZIP[0].DSXOBJCNL);
                }

            }
        } catch (error) {
            console.error("Error trying to access EgonCloud services: " + error);
        }   
    });

    $('[name = "Reg_City"]').keyup(function () {
        var country = getThreeCode($('[name = "Reg_Country"]').val());
        var city = $('[name = "Reg_City"]').val();
        try {
            jsonData = jQuery.parseJSON(httpGet("https://wpwsc.egoncloud.com:1252/Egon/EgonLstJSON?LST=LstCnl&DSXCNL=" + city + "&MAXLIVLOC=8&TPXEXT=L&USER=WPTC04LCA01&PASW=Y0YGKFKH&WPXISO=" + country));
            var options = new Array(tam - 1);
            for (let i = 0; i < tam; i++) {
                options[i] = jsonData.CNL_AREA_OUT.CNL[i].DSXOBJCNL;
            }

            $('[name = "Reg_City"]').autocomplete({ source: options });
        } catch (error) {
            console.error("Error trying to access EgonCloud services");
        }        var tam = jsonData.CNL_AREA_OUT.CNL.length;
        

    });

    $('[name = "Reg_City"]').change(function () {
        var country = getThreeCode($('[name = "Reg_Country"]').val());
        var city = $('[name = "Reg_City"]').val();
        try {
            jsonData = jQuery.parseJSON(httpGet("https://wpwsc.egoncloud.com:1252/Egon/EgonLstJSON?LST=LstCnl&DSXCNL=" + city + "&MAXLIVLOC=8&TPXEXT=L&USER=WPTC04LCA01&PASW=Y0YGKFKH&WPXISO=" + country));
            if (jsonData.CNL_AREA_OUT.CNL.length >= 1 && $('[name = "Reg_City"]').val() != "") {
                $('[name = "Reg_ZipCode"]').val(jsonData.CNL_AREA_OUT.CNL[0].CDXZIP);
            }
        } catch (error) {
            console.error("Error trying to access EgonCloud services: " + error);
        }        
        

    });

    function httpGet(theUrl) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", theUrl, true); // false for synchronous request
        xmlHttp.send(null);
        return xmlHttp.responseText;
    }

    var validation = $('.needs-validation').each(function(index, form) {
        $(this).on('submit',
            function(event) {

                console.log($(this).find("input[name='completed_captcha']"));

                if (form.checkValidity() === false ||
                    $(this).find("input[name='completed_captcha']").val() != 'valid') {
                    event.preventDefault();
                    event.stopPropagation();
                    form.classList.add('was-validated');
                }

                if (!event.isDefaultPrevented()) {
                    event.preventDefault();
                    grecaptcha.reset();
                }

                console.log($("#completed_captcha").val() != 'valid');
                console.log(form.checkValidity() === false);

            });
    });

    $("#mi-corpo-colos-new-registration-tab").on('click',
        function () {
            $(".mi-corpo-colos-message-announce").hide();

        });
    $("#mi-corpo-colos-download-tab").on('click',
        function () {
            $(".mi-corpo-colos-message-announce").hide();

        });
    $("#mi-corpo-colos-activate-forgot-tab").on('click',
        function () {
            $(".mi-corpo-colos-message-announce").hide();

        });

    // Build "download my files" link on mousedown click to anticipate click event
    // Download Form
    $("#mi-corpo-colos-download-form-button").on('click',
        function() {
            var serializedResponse = getDownloadPDF();
            var response = serializedResponse.responseText
                ? JSON.parse(serializedResponse.responseText)
                : JSON.parse(serializedResponse);
            renderResponseByStatusCode(response.ResponseCode, response.Message);
            if (response.ResponseCode == 200) {
                $('#mi-corpo-colos-success-announce-download-form').toggle();
            }
        });

    //Activation/Forgotten Form
    $("#mi-corpo-colos-activation-code").on('click',
        function () {
            var serializedResponse = getActivationCode();

            var response = serializedResponse.responseText
                ? JSON.parse(serializedResponse.responseText)
                : JSON.parse(serializedResponse);
            renderResponseByStatusCode(response.ResponseCode, response.Message);
            if (response.ResponseCode == 200) {
                $('#mi-corpo-colos-success-announce-activation-code').toggle();
                $('#mi-corpo-colos-activation-code-result').html("<p style='color:black'>Your activation code is:</p> <b><p>" + response.Message + "</p></b>");
            }

        });

    //Registration Form
    $("#mi-corpo-colos-new-registration-button").on('click',
        function() {
            var serializedResponse = getNewRegister();

            var response = serializedResponse.responseText
                ? JSON.parse(serializedResponse.responseText)
                : JSON.parse(serializedResponse);

            renderResponseByStatusCode(response.ResponseCode, response.Message);
            if (response.ResponseCode == 200) {
                $('#mi-corpo-colos-success-announce-new-registration').toggle();
            }
        });

    $("#mi-corpo-colos-pre-checkbox").on('click',
        function() {
            if ($(this).prop("checked")) {
                $("#mi-corpo-colos-pre-button").prop("disabled", false);
            } else {
                $("#mi-corpo-colos-pre-button").prop("disabled", true);
            }
        });

    $("#mi-corpo-colos-pre-button").on("click",
        function() {

            $(".mi-corpo-colos-new-registration-content-hidden").addClass("mi-corpo-colos-new-registration-content");
            $(".mi-corpo-colos-new-registration-content").removeClass("mi-corpo-colos-new-registration-content-hidden");

            //$(".mi-corpo-colos-activate-forgot-content-hidden").addClass("mi-corpo-colos-activate-forgot-content");
            //$(".mi-corpo-colos-activate-forgot-content").removeClass("mi-corpo-colos-activate-forgot-content-hidden");

            //$(".mi-corpo-colos-download-content-hidden").addClass("mi-corpo-colos-download-content");
            //$(".mi-corpo-colos-download-content").removeClass("mi-corpo-colos-download-content-hidden");

            $(".mi-corpo-colos-info-announce-hidden").addClass("mi-corpo-colos-info-announce");
            $(".mi-corpo-colos-info-announce").removeClass("mi-corpo-colos-info-announce-hidden");

            $(".mi-corpo-colos-new-registration-agreement").hide();
        });

    $("#mi-corpo-colos-success-announce-new-registration button").on('click',
        function() {
            window.location.href = window.location.href;
        });

    $("#mi-corpo-colos-success-announce-activation-code button").on('click',
        function () {
            window.location.href = window.location.href;
        });

    $("#mi-corpo-colos-success-announce-download-form button").on('click',
        function () {
            window.location.href = window.location.href;
        });

    $('#mi-corpo-colos-get-versions').on('click',
        function () {
            getVersions();
            if ($('#Down_Version').val() != '' && $('#Down_Version').val() != null) {
                $('.mi-corpo-colos-packages').prop('disabled', false);
            }
        });

    $('#chkFreeWare').on('click',
        function() {

            if ($(this).prop('checked')) {
                $('#Act_TrackingNumber').prop('required', false);
                $('#Act_TrackingNumber').next().removeClass('invalid-feedback');
                $('#Act_TrackingNumber').next().toggle();
                $('#Act_TrackingNumber').prop('disabled', true);

            } else {
                $('#Act_TrackingNumber').prop('required', true);
                $('#Act_TrackingNumber').next().addClass('invalid-feedback');
                $('#Act_TrackingNumber').next().toggle();
                $('#Act_TrackingNumber').prop('disabled', false);
            }
        });

    $('#chkDownloadFreeWare').on('click',
        function () {

            if ($(this).prop('checked')) {
                $('#Down_TrackingNumber').prop('required', false);
                $('#Down_TrackingNumber').next().removeClass('invalid-feedback');
                $('#Down_TrackingNumber').next().toggle();
                $('#Down_TrackingNumber').prop('disabled', true);
                $('#mi-corpo-colos-get-versions').attr("disabled", true);
                $('#mi-corpo-colos-get-versions').addClass('mi-corpo-colos-download-getversion-button-disabled');
                $('#Down_Version').prop('required', false);
                $('#Down_Version').next().removeClass('invalid-feedback');
                $('#Down_Version').next().toggle();
                $('#Down_Version').prop('disabled', true);
                $('.mi-corpo-colos-packages').prop('disabled', false);
                $('#mi-corpo-colos-packages-driverpack').hide();
  
            } else {
                $('#Down_TrackingNumber').prop('required', true);
                $('#Down_TrackingNumber').next().addClass('invalid-feedback');
                $('#Down_TrackingNumber').next().toggle();
                $('#Down_TrackingNumber').prop('disabled', false);
                $('#mi-corpo-colos-get-versions').attr("disabled", false);
                $('#mi-corpo-colos-get-versions').removeClass('mi-corpo-colos-download-getversion-button-disabled');
                $('#Down_Version').prop('required', true);
                $('#Down_Version').next().addClass('invalid-feedback');
                $('#Down_Version').next().toggle();
                $('#Down_Version').prop('disabled', false);
                $('.mi-corpo-colos-packages').prop('disabled', true);
                $('#mi-corpo-colos-packages-driverpack').show();

            }
        });

    $('input[type="text"], textarea').on('blur change', function (e) {
        var $this = $(this); var val = $this.val(); if (val.trim() === val) { e.preventDefault(); return false; }
        else { $this.val(val.trim()); $this.change(); }
    });

});

function geoLocalizationCOLOS() {
    $.getJSON("https://api.ipify.org?format=json",
        function(data) {
            $.getJSON("/Sitefinity/Public/Services/GeoLocation/GeoLocation.svc/" + data.ip,
                    function() {
                    })
                .done(function(userIpCountry) {
                    var jsonParse = JSON.parse(userIpCountry);

                    if (jsonParse.ErrorMessage) {
                        alert("Error ocurred while detecting user location");
                    } else {
                        saveAccessAndCheckAllowedCountry(
                            jsonParse.Ip,
                            jsonParse.GeoLocationDateTime,
                            jsonParse.IsoCode,
                            jsonParse.Country,
                            jsonParse.City,
                            jsonParse.Region
                        );
                        return userIpCountry;
                    }
                })
                .fail(function() {
                    //alert('fail=' + data);
                })
                .always(function() {
                    //console.log( "complete" );
                    $("#mi-corpo-elcacolos-loading-img").css("display", "none");

                });
        });

}

function saveAccessAndCheckAllowedCountry(ip, dateTime, isocode, country, city, region) {
    var queryString = "?" +
        $(".mi-corpo-CoLOS-hidden-data-form").serialize() +
        "&ip=" +
        ip +
        "&dateTime=" +
        dateTime +
        "&isocode=" +
        isocode +
        "&country=" +
        country +
        "&city=" +
        city +
        "&region=" +
        region +
        "&lang=" +
        document.documentElement.lang;
    var requestManager = new AsyncRequestManager();
    requestManager.renderSyncRequest('/CoLOS/saveAccessAndCheckAllowedCountry', queryString, '#mi-corpo-colos-form');
}

function getVersions() {
    var trackingNumber = $("#Down_TrackingNumber").val().trim();

    var options = {
        url: "/CoLOS/GetVersions",
        async: false,
        data: { trackingNumber: trackingNumber },
        type: "PUT",
        success: function(result) {
            var jsonParse = JSON.parse(result);

            if (jsonParse.ResponseCode == 200) {
                $(".mi-corpo-colos-message-announce").hide();

                // Remove options from selector and fill with the versions provided by the API
                $('.versionPicker')
                    .find('option')
                    .remove();
                var listVersion = JSON.parse(jsonParse.Message);
                for (i = 0; i < listVersion.length; i++) {
                    $(".versionPicker")
                        .append('<option value="' + listVersion[i] + '">' + listVersion[i] + '</option>');
                }

            } else {
                $(".mi-corpo-colos-message").text(jsonParse.Message);
                $(".mi-corpo-colos-message-announce").css('display', 'flex');
            }
        },
        error: function(result) {
            var jsonParse = JSON.parse(result);
            $(".mi-corpo-colos-message").val(jsonParse.Message);
            $(".mi-corpo-colos-message").css('display', 'flex');
        }
    };
    return $.ajax(options);
}

function getActivationCode() {

    var activationData = {
        serialNumber: $("#Act_SerialNumber").val().trim(),
        trackingNumber: $("#Act_TrackingNumber").val().trim(),
        freeware: $('#chkFreeWare').prop('checked'),
        registeredEmail: $("#Act_registeredEmail").val().trim()
    };

    var isMandatoryDataComplete = activationFieldsFilled(activationData);

    if (isMandatoryDataComplete) {
        if ($('#mi-corpo-colos-activate-forgot-captcha').val() == "valid") {
            $('#mi-corpo-colos-activate-forgot-invalid-recaptcha').hide();
            return $.ajax({
                url: "/CoLOS/GetActivationCode",
                async: false,
                data: activationData,
                type: "PUT",
                success: function (result) {
                    //var response = JSON.parse(result);
 
                },
                error: function() {
                    alert("Error loading the activation code.");
                }
            });
        } else {
            $('#mi-corpo-colos-activate-forgot-invalid-recaptcha').show();
            var response =
                '{"ResponseCode": 500,"Message":"Please Complete Google Recaptcha"}';
            return response;
        }

    } else {
        var response =
            '{"ResponseCode": 500,"Message":"There are required fields not filled under the form"}';
        return response;
    }
}

function activationFieldsFilled(activationData) {
    if (activationData.freeware) {
        var isMandatoryDataComplete = activationData.serialNumber != "" &&
            activationData.registeredEmail;
    } else {
        var isMandatoryDataComplete = activationData.serialNumber != "" &&
            activationData.trackingNumber != "" &&
            activationData.registeredEmail;
    }
    return isMandatoryDataComplete;
}

function getNewRegister() {
    var registerData = {
        companyName: $("#Reg_CompanyName").val(),  
        freeware: $('#chkRegistrationFreeware').prop('checked'),
        country: $("#SelectCountry option:selected").val(),
        email: $("#Reg_Email").val().trim(),
        chkTerms: $("#chkTerms").prop('checked'),
    };


    var isMandatoryDataComplete = registrationFieldsFilled(registerData);

    if (isMandatoryDataComplete) {
        if ($('#mi-corpo-colos-register-captcha').val() == "valid") {
            $('#mi-corpo-colos-registration-invalid-recaptcha').hide();
            return $.ajax({
                url: "/CoLOS/GetNewRegistration",
                async: false,
                data: registerData,
                type: "PUT",
                success: function(result) {
                    // OK
                },
                error: function() {
                    console.log("Error registering.");
                }
            });
        } else {
            $('#mi-corpo-colos-registration-invalid-recaptcha').show();
            var response =
                '{"ResponseCode": 500,"Message":"Please Complete Google Recaptcha"}';
            return response;
        }

    } else {
        var response =
            '{"ResponseCode": 500,"Message":"There are required fields not correctly filled."}';
        return response;
    }
}

function registrationFieldsFilled(registerData) {
       var isMandatoryDataComplete =
        registerData.companyName != "" &&
        registerData.country != "" &&
        registerData.email != "" &&
        registerData.chkTerms;
 
        return isMandatoryDataComplete;
}

function getDownloadPDF() {

    var packageType = []; //&packageType=";

    if ($('#chkSoftware').prop('checked')) {
        packageType.push(3);
    }
    if ($('#chkLanguagePack').prop('checked')) {
        packageType.push(2);
    }
    if ($('#chkUserGuides').prop('checked')) {
        packageType.push(4);
    }
    if ($('#chkExtras').prop('checked')) {
        packageType.push(5);
    }
    if ($('#chkHelpPack').prop('checked')) {
        packageType.push(1);
    }
    if ($('#chkDriverPack').prop('checked')) {
        packageType.push(6);
    }
    let versionNoTemp;
    if ($("#Down_Version").val() == null){
        versionNoTemp = "";
    }
    else {
        versionNoTemp = $("#Down_Version").val();
    }
    var downloadData = {
        registeredEmail: $("#Down_Email").val().trim(),
        trackingNumber: $("#Down_TrackingNumber").val().trim(),
        freeware: $('#chkDownloadFreeWare').prop('checked'),
        versionNo: versionNoTemp.trim(),
        packageType: packageType.join()
    };

    var isMandatoryDataComplete = downloadFieldsFilled(downloadData);

    if (isMandatoryDataComplete) {
        if ($('#mi-corpo-colos-download-captcha').val() == "valid") {
            $('#mi-corpo-colos-download-invalid-recaptcha').hide();
            return $.ajax({
                url: "/CoLOS/Download",
                async: false,
                data: downloadData,
                type: "PUT",
                success: function(result) {
                    //OK
                },
                error: function() {
                    alert("Error registering.");
                }
            });
        } else {
            $('#mi-corpo-colos-download-invalid-recaptcha').show();
            var response =
                '{"ResponseCode": 500,"Message":"' + $('#ElcaColosResponseCodeCompleteGoogleRecaptcha').text() + '"}';
            return response;
        }
    } else {
        var response =
            '{"ResponseCode": 500,"Message":"' + $('#ElcaColosResponseCodeRequiredFields').text() + '"}';
        return response;
    }
}

function downloadFieldsFilled(downloadData) {
    if (downloadData.freeware) {
        var isMandatoryDataComplete = downloadData.registeredEmail != "" &&
            downloadData.packageType;
    } else {
        var isMandatoryDataComplete = downloadData.registeredEmail != "" &&
            downloadData.trackingNumber != "" &&
            downloadData.versionNo != "" &&
            downloadData.packageType;
    }
    return isMandatoryDataComplete;
}

function renderResponseByStatusCode(statusCode, message) {
    console.log(statusCode);
    if (statusCode != 200) {
        $('.mi-corpo-colos-message').text(message);
        $('.mi-corpo-colos-message-announce').css('display', 'flex');
    } else {
        $(".mi-corpo-colos-message-announce").hide();
        $('#mi-corpo-colos-form-tabs').toggle();
        $('#mi-corpo-colos-form-tabs-content').toggle();
    }

}

function captchaRegistrationCallback() {
    if (grecaptcha.getResponse(0) !== '') {
        $("#mi-corpo-colos-register-captcha").val("valid");
    }
}

function captchaActivationForgotCallback() {
    if (grecaptcha.getResponse(1) !== '') {
        $("#mi-corpo-colos-activate-forgot-captcha").val("valid");
    }
}

function captchaDownloadCallback() {
    console.log(grecaptcha.getResponse());
    if (grecaptcha.getResponse(2) !== '') {
        $("#mi-corpo-colos-download-captcha").val("valid");
    }
}